import { render, staticRenderFns } from "./remitDataLazada.vue?vue&type=template&id=669c2610&scoped=true"
import script from "./remitDataLazada.vue?vue&type=script&lang=js"
export * from "./remitDataLazada.vue?vue&type=script&lang=js"
import style0 from "./remitDataLazada.vue?vue&type=style&index=0&id=669c2610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c2610",
  null
  
)

export default component.exports